import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class MemberLoadingService {
  private loadingSubject = new BehaviorSubject<boolean>(false);

  public readonly isLoading$ = this.loadingSubject.asObservable();

  public setLoadingStatus(value: boolean): void {
    this.loadingSubject.next(value);
  }
}
